export const appCdnURL = "https://fedmarketing.htcdn-a.com/fe-oj-ninja/"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"核桃OJ是一款面向信奥赛的OJ平台，提供海量题库题解，定期举办OI、IOI、ACM、乐多等赛制的比赛，模拟真实比赛的IO模式。备考CSP、NOI、蓝桥杯、YCL、NOC等赛事的用户可以在核桃OJ上快速提升编程能力。"},{"name":"keyword","content":"核桃OJ,核桃编程,CSP,NOI,蓝桥杯,ACM,OI,IOI,乐多,文件IO,标准IO,OJ平台,OJ,赛事,信奥赛"}],"link":[{"rel":"shortcut icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"dns-prefetch","href":"https://img.hetao101.com"},{"rel":"dns-prefetch","href":"https://public.hetaoimg.com"},{"rel":"prefetch","as":"script","href":"https://public.hetaoimg.com/fe/monaco-editor/0.52.2/min/vs/loader.js"},{"rel":"prefetch","as":"script","href":"https://img.hetao101.com/htoj/fe/monaco-editor/0.52.2/min/vs/loader.js"},{"rel":"prefetch","as":"script","href":"https://public.hetaoimg.com/fe/katex/0.16.22/dist/katex.min.js"},{"rel":"prefetch","as":"script","href":"https://img.hetao101.com/htoj/fe/katex/0.16.22/dist/katex.min.js"}],"style":[],"script":[{"tagPosition":"head","textContent":"var _hmt=_hmt||[];(function(){var a=document.createElement(\"script\");a.src=\"https://hm.baidu.com/hm.js?cf660697a2c362c105fb2f99302df148\";var b=document.getElementsByTagName(\"script\")[0];b.parentNode.insertBefore(a,b)})();\n"},{"tagPosition":"head","textContent":"(function(){if(window.globalThis||(window.globalThis=window),window.queueMicrotask||(window.queueMicrotask=function(a){Promise.resolve().then(a).catch(a=>setTimeout(()=>{throw a},0))}),!window.WeakRef){var a=new WeakMap;window.WeakRef=class b{constructor(b){a.set(this,b)}deref(){return a.get(this)}}}if([].at||(Array.prototype.at=function(a){return a=Math.trunc(a)||0,0>a&&(a+=this.length),0>a||a>=this.length?void 0:this[a]}),[].flat||(Array.prototype.flat=function(a){var b=Object(this),c=void 0===a?1:+a;isNaN(c)&&(c=0),0>c&&(c=0);var d=[];return function a(b,c){for(var e=0;e<b.length;e++)if(e in b){var f=b[e];Array.isArray(f)&&0<c?a(f,c-1):d.push(f)}}(b,c),d}),[].flatMap||(Array.prototype.flatMap=function(a,b){for(var c=Object(this),d=c.length>>>0,e=[],f=0;f<d;f++)if(f in c){var g=a.call(b,c[f],f,c);e=e.concat(g)}return e}),[].findLastIndex||(Array.prototype.findLastIndex=function(a,b){for(var c=this,d=c.length>>>0,e=d-1;0<=e;e--)if(e in c&&a.call(b,c[e],e,c))return e;return-1}),Promise.allSettled||(Promise.allSettled=function(a){var b=a.map(a=>Promise.resolve(a));return Promise.all(b.map(function(a){return a.then(function(a){return{status:\"fulfilled\",value:a}}).catch(function(a){return{status:\"rejected\",reason:a}})}))}),!window.matchMedia(\"all\").addEventListener){const a=window.matchMedia,b=a=>(\"function\"==typeof a.addListener&&(a.addEventListener=function(b,c){\"change\"===b&&a.addListener(c)}),a);window.matchMedia=c=>{var d=a(c);return b(d)}}\"undefined\"==typeof ClipboardItem&&(window.ClipboardItem=class{constructor(a){this.data=a}get types(){return Object.keys(this.data)}getType(a){if(!this.data[a])return Promise.reject(new Error(`Type ${a} not found in ClipboardItem`));const b=this.data[a];return Promise.resolve(b)}}),navigator.clipboard||(navigator.clipboard={},navigator.clipboard.write=function(a){Array.isArray(a)||(a=[a]);const b=a.find(function(a){return a.types.includes(\"text/plain\")||a.types.includes(\"text/html\")});if(!b)return Promise.reject(new Error(\"iOS 12\\u53EA\\u652F\\u6301\\u6587\\u672C\\u590D\\u5236\"));try{const a=b.types.includes(\"text/plain\")?\"text/plain\":\"text/html\";return b.getType(a).then(function(a){return a instanceof Blob?a.text():a}).then(function(a){return navigator.clipboard.writeText(a)})}catch(a){return console.warn(\"ClipboardItem polyfill: \\u65E0\\u6CD5\\u590D\\u5236\\u6587\\u672C\",a),Promise.reject(new Error(\"iOS 12\\u53EA\\u652F\\u6301\\u6587\\u672C\\u590D\\u5236\"))}})})();"},{"tagPosition":"bodyClose","textContent":"(function(){var c=location.pathname.match(/^\\/([^/]+)/),a=c&&!/^(oj|admin|callback)$/.test(c[1])?c[1]:localStorage.getItem(\"KEY_ZONE\")||\"cpp\";window.BASE_URL=c&&c[1],window.__NUXT__.config.app.baseURL=\"/\"+a})();\n"},{"type":"application/ld+json","tagPosition":"bodyClose","textContent":"{\"@context\":\"https://schema.org\",\"@type\":\"Organization\",\"url\":\"https://htoj.com.cn\",\"logo\":\"https://htoj.com.cn/logo.png\",\"name\":\"核桃OJ-CSP、NOI备考首选的在线评测平台\",\"description\":\"核桃OJ是一款面向信奥赛的OJ平台，提供海量题库题解，定期举办OI、IOI、ACM、乐多等赛制的比赛，模拟真实比赛的IO模式。备考CSP、NOI、蓝桥杯、YCL、NOC等赛事的用户可以在核桃OJ上快速提升编程能力。\",\"email\":\"oj@hetao101.com\"}\n"}],"noscript":[],"title":"核桃OJ-CSP、NOI备考首选的在线评测平台","htmlAttrs":{"lang":"zh-CN"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true